function correct(text) {
  return text.replace(/'/g, '').replace(/’/g, '').replace(/–/g, '-').replace(/–/g, '-').replace(/[\ ]{2,}/g, ' ').replace(/\n/g, '').replace(/(\&shy;|­|&#173;)/gi, '').replace(/\u00AD/g, '');
}
function correctNote(text) {
  return text.replace(/'/g, '').replace(/’/g, '').replace(/–/g, '-');
}

function footnoteFormatter(footnote) {
  let mynode = footnote.cloneNode(true);
  const triangle = mynode.querySelector('.ns-style-triangle'),
    square = mynode.querySelector('.ns-style-square'),
    hook = mynode.querySelector('.ns-style-hook'),
    diamond = mynode.querySelector('.ns-style-diamond');
  if (triangle)
    triangle.innerHTML = '▲';

  if (square)
    square.innerHTML = '◼';

  if (diamond)
    diamond.innerHTML = '◆';

  if (hook)
    hook.innerHTML = '✓';

  let content = mynode.innerText.trim();

  return content.replace('\n', ' ');

}

const font = {
  color: {
    argb: '0000376E'
  }
}

const fontBold = {
  bold: true,
  color: {
    argb: '0000376E'
  }
}

const borderRegular = {
  style: 'thin',
  color: {
    argb: 'FFCCD7E2'
  }
}

const borderRegularDark = {
  style: 'thin',
  color: {
    argb: 'FF00376E'
  }
}

// Define a fill for background color
const fillBlueLight = {
  type: 'pattern',
  pattern: 'solid',
  fgColor: { argb: 'FFF5F7FA' }, // Yellow color in ARGB
  bgColor: { argb: 'FFF5F7FA' }
};

const xdownloaderConfig = {
  tableTitle: null,
  tableSelector: ".lc-table-wrap",
  excludeTableSelector: '',
  downloadText: [
    { lang: 'de', text: 'Excel speichern' },
    { lang: 'en', text: 'Save Excel' }
  ], // Text for downloadbutton, can be empty if you want to use an icon
  footnoteFormatter: footnoteFormatter,
  styles: [
    {
      class: 'ns-horizontal-left',
      border: {
        bottom: borderRegular,
      }
    },
    {
      class: 'ns-horizontal-right',
      border: {
        bottom: borderRegular,
      }
    },
    {
      class: 'ns-horizontal-center',
      border: {
        bottom: borderRegular,
      }
    },
    {
      class: 'head',
      font: fontBold,
      border: {
        bottom: borderRegularDark,
      },
      head: true
    },
    {
      class: 'demi_bg_bline',
      font: fontBold,
      border: {
        bottom: borderRegularDark,
      }
    },
    {
      class: 'med_line',
      font: fontBold,
      border: {
        bottom: borderRegularDark,
      }
    },
    {
      class: 'head_noline',
      font: fontBold,
      border: {
        bottom: null,
      }
    },
    {
      class: 'med_noline',
      font: fontBold,
      border: {
        bottom: null,
      }
    },
    {
      class: 'spacer',
      border: {
        bottom: null,
      }
    },
    {
      class: 'line',
      font: font,
      border: {
        bottom: borderRegular,
      }
    },
    {
      class: 'line_bold',
      font: fontBold,
      border: {
        bottom: borderRegular,
      }
    },
    {
      class: 'bline',
      font: font,
      border: {
        bottom: borderRegularDark,
      },
      index: 2
    },
    {
      class: 'bline_bold',
      font: fontBold,
      border: {
        bottom: borderRegularDark,
      },
      index: 2
    },
    {
      class: 'line_ind',
      font: font,
      border: {
        bottom: borderRegular,
      },
    },
    {
      class: 'noline_bold',
      font: fontBold
    },
    {
      class: 'akt_jahr',
      fill: fillBlueLight // Adding the fill to the akt_jahr class
    },
    {
      class: 'ns-background-10',
      fill: fillBlueLight // Adding the fill to the akt_jahr class
    },
    {
      font: font,
      border: {
        bottom: borderRegular,
      }
    }
  ], // cell Styles from classes
  // numFmt, // numFmt overwrite for custom formatting
  // mergeStrings, // Set mergeStrings for all Tables
  tableCellFormatter: function (td) {
    let cellIndex = Array.from(
      td.parentElement.children
    ).indexOf(td);

    let content = "";
    let cell = document.createElement('td');
    cell.innerHTML = td.innerHTML;


    const triangle = cell.querySelector('.triangle'),
      square = cell.querySelector('.square'),
      diamond = cell.querySelector('.diamond'),
      hook = cell.querySelector('.hook');

    if (triangle)
      triangle.innerHTML = '▲';

    if (square)
      square.innerHTML = '◼';

    if (diamond)
      diamond.innerHTML = '◆';

    if (hook)
      hook.innerHTML = '✓';

    let superscript = cell.querySelector('.superscript');
    let superscriptContent = '';
    if (superscript) {
      superscriptContent = '(' + superscript.innerText.replace(/\)/g, '').replace(/\(/g, '') + ')';
      superscript.parentNode.removeChild(superscript);
    }
    if (td.querySelector('.note__link')) {
      content = correctNote(cell.innerText.trim() + ' ' + superscriptContent);
    } else {
      content = correct(cell.innerText.trim() + ' ' + superscriptContent);

      if (square || triangle || diamond) {
        content = content.replace(/\n/g, '').replace(/\ /g, '').trim();
      }
    }

    if (cellIndex == 0 && td.classList.contains('line_ind') && content.trim() != '') {
      content = '   ' + content;
    }

    return content;
  },
};

export default xdownloaderConfig;
